import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faItchIo, faBluesky, faLinkedin, faGithub, faTelegram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const Footer = ({ onContactClick }) => (
    <footer className="site-footer">
        <div className="site-footer__links">
            <a href='https://delunado.itch.io/' target="_blank" rel="noopener noreferrer" onClick={onContactClick}>
                <FontAwesomeIcon icon={faItchIo} className="contact-icon" />
            </a>
            <a href='https://t.me/delunado' target="_blank" rel="noopener noreferrer" onClick={onContactClick}>
                <FontAwesomeIcon icon={faTelegram} className="contact-icon" />
            </a>
            <a href='https://bsky.app/profile/delunado.com' target="_blank" rel="noopener noreferrer" onClick={onContactClick}>
                <FontAwesomeIcon icon={faBluesky} className="contact-icon" />
            </a>
            <a href='https://www.linkedin.com/in/javi-camacho/' target="_blank" rel="noopener noreferrer" onClick={onContactClick}>
                <FontAwesomeIcon icon={faLinkedin} className="contact-icon" />
            </a>
            <a href='https://github.com/Delunado' target="_blank" rel="noopener noreferrer" onClick={onContactClick}>
                <FontAwesomeIcon icon={faGithub} className="contact-icon" />
            </a>
            <a href='mailto:delunadogames@gmail.com' rel="noopener noreferrer" onClick={onContactClick}>
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
            </a>
        </div>
        <p className="site-footer__copy">delunadogames@gmail.com</p>
    </footer>
);

export default Footer;
